import { useState } from 'react';
import { faqs } from '@/mocks/faq';
import { Link } from 'react-router-dom';

function FAQItem({ faq, isOpen, onToggle }: { faq: typeof faqs[0]; isOpen: boolean; onToggle: () => void }) {
  return (
    <div className="border border-background-200/70 rounded-lg overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
      >
        <span className="text-sm font-medium text-foreground-900 pr-4">{faq.question}</span>
        <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
          <i className="ri-arrow-down-s-line text-foreground-500 text-base w-4 h-4 flex items-center justify-center"></i>
        </div>
      </button>
      {isOpen && (
        <div className="px-5 pb-5">
          <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            您关心的，我们都已准备好答案
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {faqs.slice(0, 6).map((faq) => (
            <FAQItem
              key={faq.id}
              faq={faq}
              isOpen={openId === faq.id}
              onToggle={() => setOpenId(openId === faq.id ? null : faq.id)}
            />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/faq-cat"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
          >
            查看更多常见问题
            <i className="ri-arrow-right-line text-base w-3.5 h-3.5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}